import API from "@utils/request";
let Language = localStorage.getItem('currentLanguage');  //获取本地语言
let prout = 'protal';
if (!Language || Language == 'zh') {
    prout = 'protal';
} else {
    prout = 'protal_' + Language;
}


// 驻站专家-列表

export async function getExpertList(params) {
    try {
        return await API.post("/api/" + prout + "/api/expert/expertList", params);
    } catch (error) {
        return error;
    }
}

export async function getDynamicList(params) {
    try {
        return await API.post("/api/" + prout + "/api/expert/dynamicList", params);
    } catch (error) {
        return error;
    }
}

export async function getExpertInfo(params) {
    try {
        return await API.post("/api/" + prout + "/api/expert/myExpertInfo", params);
    } catch (error) {
        return error;
    }
}
export async function getExpertCompose(params) {
    try {
        return await API.post("/api/" + prout + "/api/expert/getExpertCompose", params);
    } catch (error) {
        return error;
    }
}
export async function getReplyList(params) {
    try {
        return await API.post("/api/" + prout + "/api/expert/getReplyList", params);
    } catch (error) {
        return error;
    }
}
export async function getMyReplyList(params) {
    try {
        return await API.post("/api/" + prout + "/api/expert/getMyReplyList", params);
    } catch (error) {
        return error;
    }
}
export async function promotionDetail(params) {
    try {
        return await API.post("/api/" + prout + "/api/expert/promotionDetail", params);
    } catch (error) {
        return error;
    }
}
export async function getPostList(params) {
    try {
        return await API.post("/api/" + prout + "/api/expert/getPostList", params);
    } catch (error) {
        return error;
    }
}
export async function getArticleList(params) {
    try {
        return await API.post("/api/" + prout + "/api/expert/getArticleList", params);
    } catch (error) {
        return error;
    }
}
export async function commonData() {
    try {
        return await API.post("/api/" + prout + "/api/expert/commonData");
    } catch (error) {
        return error;
    }
}
export async function applyDetail() {
    try {
        return await API.post("/api/" + prout + "/api/expert/applyDetail");
    } catch (error) {
        return error;
    }
}
export async function applySubmit(params) {
    try {
        return await API.post("/api/" + prout + "/api/expert/apply",params);
    } catch (error) {
        return error;
    }
}
export async function addPromotion(params) {
    try {
        return await API.post("/api/" + prout + "/api/expert/addPromotion", params);
    } catch (error) {
        return error;
    }
}
export async function clearPromotion(params) {
    try {
        return await API.post("/api/" + prout + "/api/expert/clearPromotion", params);
    } catch (error) {
        return error;
    }
}
export async function cancelApply(params) {
    try {
        return await API.post("/api/" + prout + "/api/expert/cancelApply", params);
    } catch (error) {
        return error;
    }
}



